import { arrayOf, Schema } from 'normalizr';


export const SITE_ALIAS_SCHEMA = new Schema(
  'siteAliases'
);

export const SITE_ALIASES_SCHEMA = {
  items: arrayOf(SITE_ALIAS_SCHEMA),
};
